import React from 'react';
import { NavLink } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { RouteBreadcrumb } from '../models/epi-model';
import { InfoBarWrapper } from './layout/info-bar-wrapper';

interface BreadcrumbsProps {
    routeBreadcrumbs: RouteBreadcrumb[],
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
    const routes = props.routeBreadcrumbs?.map(rb => {
        return {
            path: rb.route,
            breadcrumb: rb.breadcrumb?.length ? rb.breadcrumb : null,
        };
    });

    const breadcrumbs = useBreadcrumbs(routes);

    return (
        <>
            <InfoBarWrapper breadcrumbWrapper>
                {breadcrumbs.map(({
                    match,
                    breadcrumb,
                }, index) => {
                    if (breadcrumbs.length === index + 1) {
                        return (<span key={match.url}>{breadcrumb}</span>);
                    }

                    return (
                        <span key={match.url}>
                            <NavLink to={match.url}>{breadcrumb}</NavLink><span className='breadcrumbs-separator'>/</span>
                        </span>
                    );

                })}
            </InfoBarWrapper>
        </>
    );
};
